<script>
import AddLabel from './Labels.vue';
import AddContacts from './Contacts.vue';
import AddMembers from './Members.vue';
import AddDate from './Dates.vue';
import AddAttachments from './Attachments.vue';
import canDismissMixin from '../../mixins/preventDismissMixin';
import AutomationSection from './AutomationSection.vue';
import ButtonNext from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    AddLabel,
    AddContacts,
    AddMembers,
    AddDate,
    AddAttachments,
    AutomationSection,
    ButtonNext,
  },
  mixins: [canDismissMixin],
  props: {
    board: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Object,
      default: () => {},
    },
    card: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    canDeleteCards: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    agents: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['deleteCard'],
  data() {
    return {
      showOptionsMenu: false,
    };
  },
  computed: {
    additionalActions() {
      const additionalActions = [
        {
          label: this.$t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.SIDEBAR.DELETE'),
          icon: 'i-lucide-trash',
          handler: this.openDeleteCardPopup,
          disabled: !this.canDeleteCards,
          color: 'ruby',
          variant: 'outline',
        },
      ];
      return additionalActions;
    },
  },
  methods: {
    openDeleteCardPopup() {
      this.$emit('deleteCard');
    },
  },
};
</script>

<template>
  <div>
    <div class="flex justify-between">
      <label>
        {{ $t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.ADD_TO_CARD') }}
      </label>
    </div>
    <ul class="list-none ml-0 mb-0 flex flex-col gap-1.5">
      <AddMembers
        :board="board"
        :list="list"
        :card="card"
        :agents="agents"
        :disabled="readonly"
      />
      <AddLabel
        :board="board"
        :list="list"
        :card="card"
        :labels="labels"
        :disabled="readonly"
      />
      <AddDate
        :board="board"
        :list="list"
        :card="card"
        :labels="labels"
        :disabled="readonly"
      />
      <AddContacts
        :board="board"
        :list="list"
        :card="card"
        :disabled="readonly"
      />
      <AddAttachments
        :board="board"
        :list="list"
        :card="card"
        :disabled="readonly"
      />
    </ul>

    <AutomationSection
      :board="board"
      :list="list"
      :card="card"
      :disabled="readonly"
    />

    <div class="flex justify-between mt-5">
      <label>
        {{ $t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.SIDEBAR.ACTIONS') }}
      </label>
    </div>
    <ul class="list-none ml-0 mb-0 flex flex-col gap-1.5">
      <ButtonNext
        v-for="(action, index) in additionalActions"
        :key="index"
        :label="action.label"
        size="sm"
        :variant="action.variant"
        :color="action.color"
        :icon="action.icon"
        :disabled="action.disabled"
        class="w-full !justify-start"
        @click="action.handler"
      />
    </ul>
  </div>
</template>
